import React, { useRef, useEffect, useState } from 'react';
import { iconBack } from '../../assets';
import { Icon } from '../../components';
import styled from 'styled-components';

const OverlayLoading = styled.div`
  position: absolute;
  top: 0;
  display: ${(props) => props.loading ? "flex" : "none"};
  z-index: 4;
  background: #e9e9e9a2;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80vh;
  @media (max-width: 768px) {
    height: 92vh;
  }
`;

const GetPicture = ({ getPhoto, openCamera, location }) => {
  const videoRef = useRef(null);
  const photoRef = useRef(null);
  const [take, setTake] = useState(false);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [locationData, setLocationData] = useState({
    address: '',
    coordsString: ''
  });

  const getVideo = () => {
    navigator.mediaDevices
      .getUserMedia({
        video: { width: 1920, height: 1080 }
      })
      .then(stream => {
        let video = videoRef.current;
        video.srcObject = stream;
        video.play();
      })
      .catch(err => {
        console.error(err);
      });
  };

  const takePhoto = () => {
    setTake(true);
    const video = videoRef.current;
    const photo = photoRef.current;

    const width = video.videoWidth;
    const height = video.videoHeight;

    photo.width = width;
    photo.height = height;

    const ctx = photo.getContext('2d');

    // Mirror horizontal
    ctx.translate(width, 0);
    ctx.scale(-1, 1);
    ctx.drawImage(video, 0, 0, width, height);

    // Reset transform
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    const now = new Date();
    const timeString = now.toLocaleString();

    const watermarkHeight = locationData.address ? 110 : 50;

    ctx.fillStyle = 'rgba(0, 0, 0, 0.24)';
    ctx.fillRect(0, height - watermarkHeight, width, watermarkHeight);

    ctx.fillStyle = 'white';
    ctx.font = '16px Arial';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';

    if (locationData.address) {
      ctx.fillText(locationData.address, 20, height - watermarkHeight + 25);
      ctx.fillText(locationData.coordsString, 20, height - watermarkHeight + 55);
      ctx.fillText(timeString, 20, height - watermarkHeight + 85);
    } else {
      ctx.fillText(`© YourBrand 2025 | ${timeString}`, 20, height - watermarkHeight / 2);
    }

    const url = photo.toDataURL('image/jpeg', 0.5);
    getPhoto(url);
    console.log('takePhoto final', url);
  };

  useEffect(() => {
    getVideo();
  }, []);

  useEffect(() => {
    const fetchLocation = async () => {
      if (!location || location.length !== 2) return;

      setLoadingLocation(true);

      const [latitude, longitude] = location;
      const coordsString = `Lat: ${latitude.toFixed(5)}, Lon: ${longitude.toFixed(5)}`;
      let address = 'Alamat tidak ditemukan';

      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`);
        const data = await response.json();
        address = data.display_name || address;
      } catch (error) {
        console.error('Reverse geocoding error:', error);
      }

      setLocationData({ address, coordsString });
      setLoadingLocation(false);
    };

    fetchLocation();
  }, [location]);

  return (
    <div style={styles.container}>
      <button onClick={openCamera} style={styles.backIcon}>
        <Icon icon={iconBack} width="20" height="20" color="#222" />
      </button>

      <div style={styles.preview}>
        <video ref={videoRef} style={{ maxWidth: '100%', transform: 'scaleX(-1)' }} playsInline></video>
      </div>

      <div style={styles.cameraControl} className={'result' + (take ? ' hasPhoto' : '')}>
        <canvas ref={photoRef} style={{ display: 'none' }}></canvas>
        {!take && (
          <button onClick={takePhoto} style={styles.cameraButton}>
            <span style={{ fontSize: 14 }}>Ambil Foto</span>
          </button>
        )}
      </div>

      {loadingLocation && (
        <OverlayLoading loading={loadingLocation}>
          <b>Loading, mengambil lokasi…</b>
        </OverlayLoading>
      )}
    </div>
  );
};

const styles = {
  container: {
    flex: 1,
    height: '100%',
    flexDirection: 'column',
    backgroundColor: 'transparent',
  },
  backIcon: {
    width: 50,
    height: 50,
    paddingLeft: 20,
    paddingTop: 20,
    position: 'absolute',
    zIndex: 999,
  },
  preview: {
    marginTop: '25px',
    display: 'flex',
    maxHeight: '100vh',
    maxWidth: '100vw',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: "relative",
    zIndex: "0"
  },
  cameraControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 20,
    position: 'absolute',
    bottom: '80px',
    width: '100%',
  },
  cameraButton: {
    flex: 0.1,
    backgroundColor: 'var(--header-page)',
    color: '#fff',
    fontWeight: 'bold',
    borderRadius: 5,
    padding: '15px 50px',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
};

export default GetPicture;
